/* eslint-disable @typescript-eslint/no-explicit-any */
import { getApp } from 'selectors/appSelector';
import { useConsentRestrictedScripts } from 'hooks/useConsentRestrictedScripts';
import { useSelector } from 'react-redux';
import React from 'react';

export const GoogleAdServices: React.FC = () => {
  const app = useSelector(getApp);
  const context = app.config?.domain?.context;
  const fastRoutingBetweenContext = app.fastRoutingBetweenContext;
  const { scriptAdded, setScriptAdded, consentLevelAdvertising } = useConsentRestrictedScripts();

  // Load script
  React.useEffect(() => {
    if (consentLevelAdvertising && context === 'WWW' && !fastRoutingBetweenContext) {
      if (!scriptAdded) {
        window.goog_snippet_vars = function () {
          window.google_conversion_id = 940748023;
          window.google_conversion_label = 'H0qkCKzNzWIQ99nKwAM';
          window.google_remarketing_only = false;
        };
        window.goog_report_conversion = function (url: any) {
          window.goog_snippet_vars();
          window.google_conversion_format = '3';
          window.google_is_call = true;
          const opt = new Object();
          (opt as any).onload_callback = function () {
            if (typeof url != 'undefined') {
              window.location = url;
            }
          };
          const convHandler = window['google_trackConversion'];
          if (typeof convHandler == 'function') {
            convHandler(opt);
          }
        };

        window.loadJS('adwords', '//www.googleadservices.com/pagead/conversion_async.js');
        if (window.ga) {
          window.ga('set', 'allowAdFeatures', true);
        }

        if (window.gtag) {
          window.gtag('set', { allow_google_signals: true });
        }
        setScriptAdded(true);
      }
    } else {
      if (window.ga) {
        ga('set', 'allowAdFeatures', false);
      }

      if (window.gtag) {
        window.gtag('set', { allow_google_signals: false });
      }
    }
  }, [consentLevelAdvertising, context, fastRoutingBetweenContext, scriptAdded, setScriptAdded]);

  return null;
};
